import { ApiFlatItem } from "../../types/general";
import { axiosAWSConsumer as axiosConsumer } from "../../utils";

const fetchFlatItems = async (route: string): Promise<ApiFlatItem[]> => {
  try {
    const { data } = await axiosConsumer.get(route);
    return data.result;
  } catch (error) {
    return [];
  }
};

export const materialTypes = async (): Promise<ApiFlatItem[]> =>
  fetchFlatItems(`/ace/all_material`);

export const manufacturers = async (): Promise<ApiFlatItem[]> =>
  fetchFlatItems(`/ace/all_manufacturer`);

export const colors = async (): Promise<ApiFlatItem[]> =>
  fetchFlatItems(`/ace/all_color`);

export const actionsTaken = async (): Promise<ApiFlatItem[]> =>
  fetchFlatItems(`/ace/actions_taken_lookup_values`);

export const howDidOccur = async (modelNo: string): Promise<ApiFlatItem[]> =>
  fetchFlatItems(`/ace/how_did_it_occur_lookup_values?modelNo=${modelNo}`);

export const damageTypes = async (modelNo: string): Promise<ApiFlatItem[]> =>
  fetchFlatItems(`/ace/damage_type_lookup_values?modelNo=${modelNo}`);

export const specificLocations = async (
  modelNo: string
): Promise<ApiFlatItem[]> =>
  fetchFlatItems(`/ace/specific_location_lookup_values?modelNo=${modelNo}`);
